var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"name":_vm.$attrs.label,"rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
var valid = ref.valid;
return [_c('v-textarea',_vm._g(_vm._b({attrs:{"outlined":"","dense":"","single-line":"","error-messages":errors,"success":valid}},'v-textarea',Object.assign({}, {rows: 6},
      _vm.$attrs,
      {rules: undefined}),false),_vm.$listeners))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }